module.exports = __webpack_public_path__ + "static/media/provider-photo-prescriber.9afe576c.jpg";